import React from 'react';
import { companyInfo } from '../mockData';
import { MapPin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/images/logo/logo.png" alt="Elite Internacional" className="footer-logo" />
            <p className="body-small footer-text">
              Agencia de representación de futbolistas profesionales. Excelencia, profesionalidad y resultados.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="caption footer-heading">CONTACTO</h4>
            <div className="footer-info">
              <MapPin size={16} />
              <p className="caption">{companyInfo.address}, {companyInfo.city}</p>
            </div>
            <div className="footer-info">
              <Mail size={16} />
              <p className="caption">{companyInfo.email}</p>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="caption footer-heading">HORARIO</h4>
            <p className="caption">{companyInfo.schedule}</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="caption">
            © {currentYear} {companyInfo.name}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;